import React, { useRef, useState } from "react";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../assets/css/BlogsFAQ.css";

const faqGroups = [
    {
        label: "Admissions",
        icon: "01",
        questions: [
            {
                question: "How can I apply for admission to ISBM University?",
                answer: (
                    <>
                        Before you begin your application process, please make sure to
                        check the university prescribed{" "}
                        <a
                            href="/admission-procedure"
                            className="font-semibold text-[#8B1E3F] underline decoration-[#D5AD57] underline-offset-4 transition-colors hover:text-[#071A2F]"
                        >
                            admission procedure guidelines
                        </a>{" "}
                        thoroughly. After understanding the guidelines, you can begin your
                        application through the university&apos;s{" "}
                        <a
                            href="/apply-online"
                            className="font-semibold text-[#8B1E3F] underline decoration-[#D5AD57] underline-offset-4 transition-colors hover:text-[#071A2F]"
                        >
                            online admission portal
                        </a>
                        . Complete the application form, provide the required details and
                        upload the relevant documents. The admissions team will guide you
                        through the next steps.
                    </>
                ),
            },

            {
                question: "What documents are generally required for admission?",
                answer: (
                    <>
                        Applicants generally need academic mark sheets and certificates,
                        identity proof, passport-size photographs and any programme-specific
                        documents. Requirements may vary by programme and applicant
                        category. Please check specific{" "}
                        <a
                            href="/programmes"
                            className="font-semibold text-[#8B1E3F] underline decoration-[#D5AD57] underline-offset-4 transition-colors hover:text-[#071A2F]"
                        >
                            programme details and eligibility criteria
                        </a>{" "}
                        before documentation.
                    </>
                ),
            },

            {
                question: "Can I receive guidance before choosing a programme?",
                answer: (
                    <>
                        Yes. Prospective students can approach our{" "}
                        <a
                            href="/contact-us"
                            className="font-semibold text-[#8B1E3F] underline decoration-[#D5AD57] underline-offset-4 transition-colors hover:text-[#071A2F]"
                        >
                            admissions help desk
                        </a>{" "}
                        and connect with the university&apos;s admission counselors to
                        understand programme structures, eligibility, career pathways and
                        the application process.
                    </>
                ),
            },

            {
                question: "How do I pay my admission fees?",
                answer: (
                    <>
                        ISBM University has multiple options available for efficient and
                        secure fee payment for students. You can pay your fees through
                        multiple modes like cash, online transfer, credit card, demand
                        draft, online credit transfer and cheque. Read our{" "}
                        <a
                            href="/payment-procedure"
                            className="font-semibold text-[#8B1E3F] underline decoration-[#D5AD57] underline-offset-4 transition-colors hover:text-[#071A2F]"
                        >
                            payment procedure guidelines
                        </a>{" "}
                        to learn more.
                    </>
                ),
            },

            {
                question:
                    "Are there specific admission provisions for international students?",
                answer: (
                    <>
                        ISBM University provides a dedicated focus to welcome international
                        students by getting involved in the pre-arrival preparation
                        process, migration process, climate conscious student orientation
                        and so on. Visit the{" "}
                        <a
                            href="/international-students"
                            className="font-semibold text-[#8B1E3F] underline decoration-[#D5AD57] underline-offset-4 transition-colors hover:text-[#071A2F]"
                        >
                            international students page
                        </a>{" "}
                        to get better clarity.
                    </>
                ),
            },
        ],
    },

    {
        label: "Academics",
        icon: "02",
        questions: [
            {
                question: "What types of programmes does the University offer?",
                answer: (
                    <>
                        ISBM University offers undergraduate, postgraduate, diploma and
                        doctoral-level learning opportunities across multiple disciplines.
                        Visit the{" "}
                        <a
                            href="/programmes"
                            className="font-semibold text-[#8B1E3F] underline decoration-[#D5AD57] underline-offset-4 transition-colors hover:text-[#071A2F]"
                        >
                            Programmes section
                        </a>{" "}
                        for the latest programme list and eligibility information.
                    </>
                ),
            },

            {
                question:
                    "Does the University provide practical learning opportunities?",
                answer: (
                    <>
                        Yes. Depending on the programme, learning may include laboratory
                        sessions, projects, presentations, workshops, field exposure,
                        research activities and industry-oriented assignments.
                    </>
                ),
            },

            {
                question:
                    "Are libraries and digital learning resources available?",
                answer: (
                    <>
                        Students have access to a{" "}
                        <a
                            href="/library"
                            className="font-semibold text-[#8B1E3F] underline decoration-[#D5AD57] underline-offset-4 transition-colors hover:text-[#071A2F]"
                        >
                            central library
                        </a>{" "}
                        which accommodates academic books, journals, reading spaces and
                        digital learning resources that support classroom study,
                        independent learning and research.
                    </>
                ),
            },

            {
                question:
                    "What academic disciplines or schools can I choose from?",
                answer: (
                    <>
                        ISBM University is a multidisciplinary institution offering varied
                        learning opportunities bifurcated within various{" "}
                        <a
                            href="/schools"
                            className="font-semibold text-[#8B1E3F] underline decoration-[#D5AD57] underline-offset-4 transition-colors hover:text-[#071A2F]"
                        >
                            academic disciplines or schools
                        </a>
                        . You can choose a programme based on your interests and career
                        goals.
                    </>
                ),
            },

            {
                question:
                    "Does the University offer skill development programmes alongside academics?",
                answer: (
                    <>
                        Yes. ISBM University has launched a state-of-the-art skill
                        development initiative Model Training Centre (MTC), in partnership
                        with the Ministry of Skill Development & Entrepreneurship (MSDE)
                        and National Skill Development Corporation (NSDC), called Pradhan
                        Mantri Kaushal Kendra (PMKK) in Gariyabandh, Chhattisgarh.
                    </>
                ),
            },
        ],
    },

    {
        label: "Campus Life",
        icon: "03",
        questions: [
            {
                question: "What facilities are available on campus?",
                answer: (
                    <>
                        Campus facilities include classrooms, laboratories, library
                        resources, sports and recreation spaces, auditoriums, seminar
                        halls, student support services and other programme-specific
                        learning facilities.
                    </>
                ),
            },

            {
                question: "Does the University offer hostel facilities?",
                answer: (
                    <>
                        Residential facilities are available subject to campus capacity
                        and university policies. Students should contact the{" "}
                        <a
                            href="/contact-us"
                            className="font-semibold text-[#8B1E3F] underline decoration-[#D5AD57] underline-offset-4 transition-colors hover:text-[#071A2F]"
                        >
                            admissions or campus team
                        </a>{" "}
                        for current availability, charges and accommodation guidelines.
                    </>
                ),
            },

            {
                question:
                    "Are extracurricular activities available for students?",
                answer: (
                    <>
                        Yes. Students can participate in extracurricular cultural,
                        academic, sports, innovation and student-led activities that
                        support teamwork, creativity, leadership and personal development.
                    </>
                ),
            },

            {
                question:
                    "Does the University provide transportation for students?",
                answer: (
                    <>
                        Yes, we provide campus commute assistance through scheduled bus
                        services. View the{" "}
                        <a
                            href="/bus-schedule"
                            className="font-semibold text-[#8B1E3F] underline decoration-[#D5AD57] underline-offset-4 transition-colors hover:text-[#071A2F]"
                        >
                            ISBM University Bus Schedule
                        </a>{" "}
                        or contact our city office at{" "}
                        <a
                            href="tel:+919329932747"
                            className="font-semibold text-[#8B1E3F] underline decoration-[#D5AD57] underline-offset-4 transition-colors hover:text-[#071A2F]"
                        >
                            +91 93299 32747
                        </a>{" "}
                        in case of any queries.
                    </>
                ),
            },

            {
                question:
                    "What support is available for student wellbeing and grievances?",
                answer: (
                    <>
                        In case of any grievances, promptly fill in the{" "}
                        <a
                            href="/grievance"
                            className="font-semibold text-[#8B1E3F] underline decoration-[#D5AD57] underline-offset-4 transition-colors hover:text-[#071A2F]"
                        >
                            grievances form
                        </a>{" "}
                        and contact your admissions counsellor.
                    </>
                ),
            },
        ],
    },

    {
        label: "Careers",
        icon: "04",
        questions: [
            {
                question: "Does the University provide placement support?",
                answer: (
                    <>
                        The{" "}
                        <a
                            href="/training-and-placement"
                            className="font-semibold text-[#8B1E3F] underline decoration-[#D5AD57] underline-offset-4 transition-colors hover:text-[#071A2F]"
                        >
                            training and placement team
                        </a>{" "}
                        supports students through career guidance, skill-development
                        activities, interview preparation and employer engagement.
                        Opportunities depend on programme requirements and recruiter
                        criteria.
                    </>
                ),
            },

            {
                question:
                    "How does the University help students become industry-ready?",
                answer: (
                    <>
                        Career readiness is supported through practical learning,
                        communication development, projects, workshops, industry
                        interactions and programme-specific skill-building activities.
                    </>
                ),
            },

            {
                question:
                    "Does the University offer career counselling before placements begin?",
                answer: (
                    <>
                        Yes. Before the placement drives begin, ISBM University offers{" "}
                        <a
                            href="/training-and-placement"
                            className="font-semibold text-[#8B1E3F] underline decoration-[#D5AD57] underline-offset-4 transition-colors hover:text-[#071A2F]"
                        >
                            career counselling
                        </a>{" "}
                        as a pre-placement initiative.
                    </>
                ),
            },

            {
                question: "Which companies recruit from ISBM University?",
                answer: (
                    <>
                        We have honoured and thrived with a host of corporate leaders who
                        readily recruit our students, offering them a pathway towards
                        career success. Find the list of our{" "}
                        <a
                            href="/placements"
                            className="font-semibold text-[#8B1E3F] underline decoration-[#D5AD57] underline-offset-4 transition-colors hover:text-[#071A2F]"
                        >
                            top recruiters
                        </a>{" "}
                        to know where your journey with ISBM University can take you.
                    </>
                ),
            },

            {
                question:
                    "Do international partnerships support placement or career opportunities?",
                answer: (
                    <>
                        Yes. The primary objective of the{" "}
                        <a
                            href="/international-tie-ups"
                            className="font-semibold text-[#8B1E3F] underline decoration-[#D5AD57] underline-offset-4 transition-colors hover:text-[#071A2F]"
                        >
                            International Tie-ups
                        </a>{" "}
                        is aimed at fostering global academic, research and employment
                        opportunities for students, faculty, and staff members of ISBM
                        University.
                    </>
                ),
            },
        ],
    },
];

export default function FAQ() {
    const [activeGroup, setActiveGroup] = useState(0);
    const [openQuestion, setOpenQuestion] = useState("0-0");
    const selectedGroup = faqGroups[activeGroup];

    const toggleQuestion = (groupIndex, questionIndex) => {
        const key = `${groupIndex}-${questionIndex}`;
        setOpenQuestion((current) => (current === key ? "" : key));
    };

    const selectGroup = (index) => {
        setActiveGroup(index);
        setOpenQuestion(`${index}-0`);
    };

    return (
        <section className="university-faq" aria-labelledby="faq-heading">
            <div className="university-faq__shape" aria-hidden="true">?</div>
            <div className="university-section-container">
                <div className="university-faq__layout">
                    <div className="university-faq__introduction">
                        <span className="university-section-eyebrow university-section-eyebrow--light">
                            <i /> Frequently asked questions
                        </span>
                        <h2 id="faq-heading">
                            Have questions?
                            <em> Start here.</em>
                        </h2>
                        <p>
                            Find helpful information about admissions, academics, campus life
                            and career support at ISBM University.
                        </p>

                        <div className="university-faq__contact">
                            <span>Still need assistance?</span>
                            <strong>Our team is ready to help.</strong>
                            <a href="/contact-us">Contact the University <i>↗</i></a>
                        </div>
                    </div>

                    <div className="university-faq__content">
                        <div
                            className="university-faq__categories"
                            role="tablist"
                            aria-label="FAQ categories"
                        >
                            {faqGroups.map((group, index) => (
                                <button
                                    key={group.label}
                                    type="button"
                                    role="tab"
                                    aria-selected={activeGroup === index}
                                    className={activeGroup === index ? "active" : ""}
                                    onClick={() => selectGroup(index)}
                                >
                                    <span>{group.icon}</span>
                                    <strong>{group.label}</strong>
                                </button>
                            ))}
                        </div>

                        <div className="university-faq__questions" aria-live="polite">
                            <div className="university-faq__group-heading">
                                <span>{selectedGroup.icon}</span>
                                <div>
                                    <small>Questions about</small>
                                    <h3>{selectedGroup.label}</h3>
                                </div>
                            </div>

                            {selectedGroup.questions.map((item, questionIndex) => {
                                const key = `${activeGroup}-${questionIndex}`;
                                const isOpen = openQuestion === key;

                                return (
                                    <article
                                        className={`university-faq-item ${isOpen ? "open" : ""}`}
                                        key={item.question}
                                    >
                                        <h4>
                                            <button
                                                type="button"
                                                aria-expanded={isOpen}
                                                aria-controls={`faq-answer-${key}`}
                                                onClick={() =>
                                                    toggleQuestion(activeGroup, questionIndex)
                                                }
                                            >
                                                <span>{item.question}</span>
                                                <i aria-hidden="true">{isOpen ? "−" : "+"}</i>
                                            </button>
                                        </h4>
                                        <div
                                            id={`faq-answer-${key}`}
                                            className="university-faq-item__answer"
                                            aria-hidden={!isOpen}
                                        >
                                            <div>
                                                <p>{item.answer}</p>
                                            </div>
                                        </div>
                                    </article>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
